import React from "react";
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import checkPermissions from '../../shared/checkPermissions';
import checkPermissionsActions from "../../shared/checkPermissionsActions";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Cached from "@material-ui/icons/Cached";
import PaymentReports from "../../containers/PaymentReports/PaymentReports";

class PaymentReportsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enableMaintenanceCheck: '',
    }
  }

  setNotification = (message) => {
    this.setState({message});
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    
  }

  render() {
    const permitted = checkPermissions('PR');
    if (!permitted) {
      return <Redirect to="/dashboard" />;
    }
    const permissions = checkPermissionsActions("PR");
    console.log('PR state', this.state, permitted, permissions);
    return (
  <div>
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <div className="pointed">Entries</div>
            </CardIcon>
          </CardHeader>
          <CardBody>
            <PaymentReports />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>

  </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.settings.loading,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    readSettings: () => {
      dispatch(actions.readSettings());
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentReportsPage);
